import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46cd4983"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "links" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "WildSys", -1))
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "logo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import LogoSVG from '@/components/design/LogoSVG.vue'
import { ref, onBeforeUnmount, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHeader',
  setup(__props) {

const header = ref<HTMLElement|null>(null)
const headerReduced = ref(false)
const mobileMenu = ref(false)

const manageScroll = function(evt: MouseEvent){
    const scrollY = window.scrollY
    headerReduced.value = (scrollY > (header.value as HTMLElement)?.offsetHeight)
}

const attachEvents = function(){
    window.addEventListener('scroll', manageScroll)
}

const dettachEvents = function(){
    window.removeEventListener('scroll', manageScroll)
}

const smoothScroll = function(anchor){
    window.scrollTo({
        top: document.body.querySelector(anchor).offsetTop,
        behavior: 'smooth'
    })
}

onMounted(() => attachEvents())
onBeforeUnmount(() => dettachEvents())

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cmp header", {'reduced': headerReduced.value}]),
    ref_key: "header",
    ref: header
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "home",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (smoothScroll('#home')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LogoSVG, {
                fill: headerReduced.value ? '#788d9c' : '#ffffff'
              }, null, 8, ["fill"])
            ]),
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "#ctoaas",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (smoothScroll('#ctoaas')), ["prevent"])),
          class: "link"
        }, " CTO as a Service "),
        _createElementVNode("a", {
          href: "#develop",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (smoothScroll('#develop')), ["prevent"])),
          class: "link"
        }, " Développement "),
        _createElementVNode("a", {
          href: "#hosting",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (smoothScroll('#hosting')), ["prevent"])),
          class: "link"
        }, " Hébergement ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Contact ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "pwa toggle",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (mobileMenu.value = !mobileMenu.value))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'bars'] })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["pwa menu", {'active': mobileMenu.value}])
      }, [
        _createElementVNode("div", {
          class: "close",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (mobileMenu.value = false))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fal', 'circle-xmark'] })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(LogoSVG, { fill: "#788d9c" })
        ]),
        _createElementVNode("a", {
          href: "#ctoaas",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (smoothScroll('#ctoaas')), ["prevent"])),
          class: "link"
        }, " CTO as a Service "),
        _createElementVNode("a", {
          href: "#develop",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (smoothScroll('#develop')), ["prevent"])),
          class: "link"
        }, " Développement "),
        _createElementVNode("a", {
          href: "#hosting",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (smoothScroll('#hosting')), ["prevent"])),
          class: "link"
        }, " Hébergement "),
        _hoisted_7,
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Contact ")
          ]),
          _: 1
        })
      ], 2)
    ])
  ], 2))
}
}

})